import React, { Component, PropTypes } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Project from '../components/Project';

import { connect } from 'react-redux';

//Change Class per Project
class TrafficClock extends React.Component {
  render () {
    const { projects, benchmark, personalInfo } = this.props;  
    console.log(personalInfo);
    
    const featProject = projects[4];

    // const params = this.props.params || {}
    // const { title, description, year, poster, trailer } = params
    return (
      <div className='container'>
        <Header personalInfo={personalInfo} />
        <div className=''>

          <h1 className=''>TrafficClock Page </h1>

          <Project project={featProject}/>


        </div>
        <Footer personalInfo={personalInfo} />
      </div>
    )
  }
}

const { object, array } = React.PropTypes

TrafficClock.propTypes = {
  projects: PropTypes.array.isRequired,
  personalInfo: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.projects,
    personalInfo: state.personalInfo
  };
}

//Change for each project

export default connect(mapStateToProps)(TrafficClock)




/** WEBPACK FOOTER **
 ** ./src/pages/TrafficClock.js
 **/